<template>
	<div class="white-nav-bar">
		<h2><slot></slot></h2>
		<router-link
			class="nav-back"
			:class="backOrClose"
			:to="{
				name: routeName,
				params: {
					direction: direction
				}
			}"
		>
		</router-link>
	</div>
</template>

<script>
export default {
	name: 'white-nav-bar',
	props: {
		routeName: String,
		backOrClose: {
			type: String,
			default: 'back'
		}
	},
	computed: {
		direction() {
			return this.backOrClose === 'back' ? 'back' : 'down'
		}
	}
}
</script>

<style lang="scss">
.white-nav-bar {
	color: $blue;
	position: relative;
	h2 {
		padding: 0px;
		margin-bottom: 0px;
	}
	.nav-back {
		position: absolute;
		top: -4px;
		left: -40px;
		width: 40px;
		height: 40px;
		background-size: 7px 11px;
		background-position: center center;
		background-repeat: no-repeat;
		&.close {
			background-size: 11px 11px;
		}
		&:hover {
			background-color: $lighter-grey;
			border-radius: 20px;
		}
	}
}
</style>
